module.exports = __webpack_public_path__ + "img/user-group.a7629379.svg";